import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import Chart from "react-apexcharts";
import { FiCalendar } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function AttendanceOverviewCard() {

const series = [21,59,2,15];

const options = {

chart:{
type:"donut",
toolbar:{show:false}
},

labels:["Late","Present","Permission","Absent"],

colors:[
"#184f5e",
"#10b759",
"#fbbc04",
"#ef0000"
],

plotOptions:{
pie:{
startAngle:-90,
endAngle:90,
expandOnClick:false,
offsetY:10,
borderRadius:10,
paddingAngle:6,

donut:{
size:"72%"
}
}
},

stroke:{
width:8,
colors:["#ffffff"]
},

dataLabels:{
enabled:false
},

legend:{
show:false
},

grid:{
padding:{
top:-20
}
},

tooltip:{
enabled:true,
theme:"dark",
y:{
formatter:(val)=>{
return val + "%";
}
}
}

};

return(

<Card className="attendance-card h-100">

<Card.Header className="attendance-header card-header-custom">

<h5>Attendance Overview</h5>

<Dropdown>
<Dropdown.Toggle size="sm" variant="light" className="date-btn border">
<FiCalendar className="me-1"/> Today
</Dropdown.Toggle>

<Dropdown.Menu>
<Dropdown.Item>This Month</Dropdown.Item>
<Dropdown.Item>This Week</Dropdown.Item>
<Dropdown.Item>Today</Dropdown.Item>
</Dropdown.Menu>

</Dropdown>

</Card.Header>

<Card.Body>

<div className="chart-wrapper">

<Chart
options={options}
series={series}
type="donut"
height={255}
/>

<div className="chart-center">
<p>Total Attendance</p>
<h2>120</h2>
</div>

</div>

<h6 className="status-title">Status</h6>

<Status color="#10b759" label="Present" value="59%"/>
<Status color="#184f5e" label="Late" value="21%"/>
<Status color="#fbbc04" label="Permission" value="2%"/>
<Status color="#ef0000" label="Absent" value="15%"/>

<div className="absent-box">

<div className="absent-left">

<span>Total Absentees</span>

<div className="avatar-group">

<img src="https://randomuser.me/api/portraits/men/32.jpg"/>
<img src="https://randomuser.me/api/portraits/men/41.jpg"/>
<img src="https://randomuser.me/api/portraits/women/44.jpg"/>
<img src="https://randomuser.me/api/portraits/men/85.jpg"/>

<span className="avatar-more">+1</span>

</div>

</div>


<Link className="view-details" to="/leaves" >
View Details
</Link>

</div>

</Card.Body>

<style>
{`

.attendance-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
}

.attendance-header{
display:flex;
justify-content:space-between;
align-items:center;
padding:16px;
border-bottom:1px solid #eee;
}

      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
.attendance-header h5{
font-weight:600;
margin:0;
}

.date-btn{
font-size:13px;
border-radius:6px;
}

.chart-wrapper{
position:relative;
margin-top:10px;
}

.chart-center{
position:absolute;
left:50%;
top:65%;
transform:translate(-50%,-50%);
text-align:center;
}

.chart-center p{
font-size:14px;
color:#6b7280;
margin-bottom:4px;
}

.chart-center h2{
font-size:28px;
font-weight:700;
color:#111827;
margin:0;
}

.status-title{

margin-bottom:12px;
font-weight:600;
}

.status-row{
display:flex;
justify-content:space-between;
align-items:center;
font-size:14px;
margin-bottom:10px;
}

.status-row div{
display:flex;
align-items:center;
}

.status-dot{
width:10px;
height:10px;
border-radius:50%;
margin-right:8px;
}

.absent-box{
margin-top:15px;
background:#f5f6f8;
border-radius:8px;
padding:12px;
display:flex;
justify-content:space-between;
align-items:center;
}

.absent-left{
display:flex;
align-items:center;
gap:12px;
}

.avatar-group{
display:flex;
align-items:center;
}

.avatar-group img{
width:28px;
height:28px;
border-radius:50%;
border:2px solid #fff;
margin-left:-8px;
object-fit:cover;
}

.avatar-group img:first-child{
margin-left:0;
}

.avatar-more{
background:#ff6a00;
color:white;
width:28px;
height:28px;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;
font-size:12px;
margin-left:-8px;
}

.view-details{
color:#ff6a00;
font-size:14px;
text-decoration:underline;
}

`}
</style>

</Card>

);
}

function Status({label,value,color}){

return(

<div className="status-row">

<div>

<span
className="status-dot"
style={{background:color}}
></span>

{label}

</div>

<span>{value}</span>

</div>

)

}